<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E0QiHK/tc-custom/9780830874088.jpg?1696873914879" alt="This image is the cover for the book State of the Evangelical Mind"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">State of the Evangelical Mind
      </h1>
      <p class="bookDescription body article font2">
        <p>Two decades on from Mark Noll's <em>Scandal of the Evangelical Mind</em>, could we now be on the threshold of another crisis of intellectual maturity in Christianity? Or are the opportunities for faithful intellectual engagement and witness even greater now than before? These essays invite readers to a virtual "summit meeting" on the current state of the evangelical mind. The insights of national leaders in their fields will aid readers to reflect on the past contributions of evangelical institutions for the life of the mind as well as prospects for the future. Contributors include:</p>  Richard J. Mouw Mark A. Noll Jo Anne Lyon David C. Mahan and C. Donald Smedley Timothy Larsen Lauren Winner James K. A. Smith Mark Galli  <p> <em>The State of the Evangelical Mind</em> frames the resources needed for churches, universities, seminaries, and parachurch organizations to chart their course for the future, both separately and together, and provides readers an opportunity to participate in a timely conversation as they consider what institutional and individual role they might play. This is not a book to define or diagnose evangelicalism broadly, and there's no fear-mongering or demonizing here, but rather a call to attend to the evangelical mind and the role played by interlocking institutions in its intellectual formation and ongoing vitality. It will encourage—and challenge—those who want to be part of the solution in a time of need.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Todd C. Ream, Jerry A. Pattengale, Christopher J. Devers, Mark Galli, Timothy Larsen, Jo Anne Lyon, David C. Mahan, Richard J. Mouw, Mark A. Noll, James K. A. Smith, Lauren F. Winner, C. Donald Smedley
      </h2>
      
      <p class="authorDescription body article"><p>Todd C. Ream  (PhD, Penn State) is professor of higher education at Taylor University and a senior fellow with the Lumen Research Institute.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?182d99b9